"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, type ChangeEvent, type KeyboardEvent } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { NftSuggestList } from "./NftSuggestList";
import type { Suggestion } from "../types";
interface NftPickerSearchProps {
  query: string;
  isOpen: boolean;
  activeIndex: number;
  suggestionList: Suggestion[];
  hiddenCount: number;
  hideSpam: boolean;
  placeholder: string;
  variant: "card" | "flat";
  inputRef: RefObject<HTMLInputElement | null>;
  collectionInputId: string;
  activeSuggestionId?: string | undefined;
  onInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onInputKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
  onInputFocus: () => void;
  onToggleSpam: () => void;
  onHoverSuggestion: (index: number) => void;
  onSelectSuggestion: (suggestion: Suggestion) => void;
  loading?: boolean | undefined;
}
export function NftPickerSearch(t0) {
  const $ = _c(32);
  const {
    query,
    isOpen,
    activeIndex,
    suggestionList,
    hiddenCount,
    hideSpam,
    placeholder,
    variant,
    inputRef,
    collectionInputId,
    activeSuggestionId,
    onInputChange,
    onInputKeyDown,
    onInputFocus,
    onToggleSpam,
    onHoverSuggestion,
    onSelectSuggestion,
    loading
  } = t0;
  const collectionInputClassName = variant === "card" ? "tw-w-full tw-rounded-md tw-border tw-border-iron-700 tw-bg-iron-950 tw-pl-3 tw-pr-10 tw-py-[0.625rem] tw-text-sm tw-text-white focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-500" : "tw-w-full tw-bg-black tw-border tw-border-solid tw-border-white/10 tw-text-iron-300 tw-text-sm tw-rounded-lg focus:tw-ring-primary-400 focus:tw-border-primary-400 tw-pl-10 tw-pr-14 tw-py-3 placeholder:tw-text-iron-600 tw-transition-all focus:tw-outline-none";
  let t1;
  if ($[0] !== collectionInputId) {
    t1 = <label htmlFor={collectionInputId} className="tw-sr-only">Select collection</label>;
    $[0] = collectionInputId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-absolute tw-inset-y-0 tw-left-0 tw-pl-3 tw-flex tw-items-center tw-pointer-events-none"><MagnifyingGlassIcon className="tw-w-4 tw-h-4 tw-text-iron-600" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activeSuggestionId || $[4] !== collectionInputClassName || $[5] !== collectionInputId || $[6] !== inputRef || $[7] !== isOpen || $[8] !== onInputChange || $[9] !== onInputFocus || $[10] !== onInputKeyDown || $[11] !== placeholder || $[12] !== query) {
    t3 = <input id={collectionInputId} ref={inputRef} value={query} onChange={onInputChange} onKeyDown={onInputKeyDown} onFocus={onInputFocus} placeholder={placeholder} role="combobox" aria-expanded={isOpen} aria-controls="nft-picker-suggest-list" aria-activedescendant={activeSuggestionId} className={collectionInputClassName} />;
    $[3] = activeSuggestionId;
    $[4] = collectionInputClassName;
    $[5] = collectionInputId;
    $[6] = inputRef;
    $[7] = isOpen;
    $[8] = onInputChange;
    $[9] = onInputFocus;
    $[10] = onInputKeyDown;
    $[11] = placeholder;
    $[12] = query;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== loading) {
    t4 = loading && <div className="tw-absolute tw-inset-y-0 tw-right-0 tw-z-20 tw-flex tw-items-center tw-pr-3 tw-pointer-events-none"><svg className="tw-h-4 tw-w-4 tw-animate-spin tw-text-primary-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path className="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" /></svg></div>;
    $[14] = loading;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== activeIndex || $[17] !== hiddenCount || $[18] !== hideSpam || $[19] !== isOpen || $[20] !== onHoverSuggestion || $[21] !== onSelectSuggestion || $[22] !== onToggleSpam || $[23] !== suggestionList) {
    t5 = suggestionList.length > 0 && <NftSuggestList items={suggestionList} activeIndex={activeIndex} isOpen={isOpen} hiddenCount={hiddenCount} hideSpam={hideSpam} onToggleSpam={onToggleSpam} onHover={onHoverSuggestion} onSelect={onSelectSuggestion} />;
    $[16] = activeIndex;
    $[17] = hiddenCount;
    $[18] = hideSpam;
    $[19] = isOpen;
    $[20] = onHoverSuggestion;
    $[21] = onSelectSuggestion;
    $[22] = onToggleSpam;
    $[23] = suggestionList;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== t3 || $[26] !== t4 || $[27] !== t5) {
    t6 = <div className="tw-relative">{t2}{t3}{t4}{t5}</div>;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t1 || $[30] !== t6) {
    t7 = <div className="tw-flex tw-flex-col tw-gap-2">{t1}{t6}</div>;
    $[29] = t1;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
}